import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Table, Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector } from "react-redux";
// CUSTOM HOOKS
import useGetAllOrganizationsLight from "../../../customHooks/GET_requests/useGetAllOrganizationsLight";
// FILTERS
import FilterSearchText from "../filters/FilterSearchText";
// INTERFACES
import { FormularyHeaderInputSelectOrganizationInterface } from "../../../interfaces/Global.interface";
import { RootState } from "../../../app/store";

export default function FormularyHeaderInputSelectOrganization({
	formAction,
	value,
	onChangeFormValue,
	variableName,
	itemId,
	onClickCellName = () => {},
	enabledCellClick = false,
	enabledFilter = false,
	filterValue = "",
	setFilterValue = () => {},
	refreshTable = () => {},
	disableInput = false,
}: FormularyHeaderInputSelectOrganizationInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Column, ColumnGroup } = Table;
	const { Option } = Select;
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { globalOrganizationId } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { organizationsLight: organizations, isLoadingGetAllOrganizationsLight } = useGetAllOrganizationsLight();

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const getItemName = (recordId: string) => {
		const item = organizations.find((v: any) => v.id === recordId);
		return item ? item.name : "--";
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		if (globalOrganizationId && globalOrganizationId !== "") {
			if (process.env.REACT_APP_MASTER_ORG_ID !== globalOrganizationId) {
				onChangeFormValue(globalOrganizationId, variableName);
			} else {
				onChangeFormValue("", variableName);
			}
		}
	}, [globalOrganizationId]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<ColumnGroup title={t("general.organization")}>
			<Column
				className='generalStyles__hoverCursor generalStyles__width150px'
				onCell={(record: any) => ({
					onClick: () => {
						if (enabledCellClick && formAction === "create") {
							onClickCellName(record);
						}
					},
				})}
				filterDropdown={() => (
					<>
						{enabledFilter && (
							<FilterSearchText
								placeHolder={t("general.organization")}
								filterValue={filterValue}
								setFilterValue={setFilterValue}
								refreshTable={refreshTable}
								refreshRequireParamenters
							/>
						)}
					</>
				)}
				filterIcon={enabledFilter ? undefined : () => null}
				title={
					<Select
						optionFilterProp='children'
						showSearch
						allowClear={false}
						size='small'
						value={formAction === "create" ? value : null}
						disabled={
							formAction === "edit" ||
							organizations.length === 0 ||
							process.env.REACT_APP_MASTER_ORG_ID !== globalOrganizationId ||
							disableInput
						}
						className='generalStyles__width150px'
						placeholder={t("general.organization")}
						onChange={(e: string | number) => {
							onChangeFormValue(e, variableName);
						}}
						loading={isLoadingGetAllOrganizationsLight}
					>
						{organizations.map((item: any) => (
							<Option key={item.id} value={item.id}>
								{item.name}
							</Option>
						))}
					</Select>
				}
				dataIndex={variableName}
				key={variableName}
				render={(text, record: any) => (
					<div>
						{formAction === "edit" && record.id === itemId ? (
							<Select
								optionFilterProp='children'
								allowClear={false}
								size='small'
								value={value}
								className='generalStyles__width150px'
								placeholder={t("general.organization")}
								onChange={(e: string | number) => {
									onChangeFormValue(e, variableName);
								}}
								loading={isLoadingGetAllOrganizationsLight}
								disabled={disableInput}
							>
								{organizations.map((item: any) => (
									<Option key={item.id} value={item.id}>
										{item.name}
									</Option>
								))}
							</Select>
						) : (
							<div>{getItemName(text)}</div>
						)}
					</div>
				)}
			/>
		</ColumnGroup>
	);
}
